import { Component, OnInit } from '@angular/core';
import { MainService } from '../service/main.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../apiRouts';
import { LocalStorageService } from '../service/local-storage.service';
import { ToasterServiceService } from '../service/toaster.service';

@Component({
  selector: 'app-sub-event',
  templateUrl: './sub-event.component.html',
  styleUrl: './sub-event.component.scss'
})
export class SubEventComponent implements OnInit{
  getSubEventListMain: any;
  getSubEventList: any;
  eventId: any;
  userTypeId: any;
  label: any;
  constructor(    
    private mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private toasterService: ToasterServiceService,
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.label = this.userTypeId == 1 ? 'આમંત્રણ અને હાજર સભ્ય' : 'આમંત્રણ'
    this.route.params.subscribe((params: any) => {
      this.eventId = params['event_id'] || '';
    });

  }

  ngOnInit(): void {
    this.getSubEventListData();
  }

  getSubEventListData() {
    this.mainService.getApi(ApiUrls.subEventList + this.eventId).subscribe(res => {
      this.getSubEventListMain = res.sub_event;
      this.getSubEventList = res.sub_event;
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getSubEventList = this.getSubEventListMain
      return;
    }
    this.getSubEventList = this.getSubEventListMain.filter((user: any) => {
      return user.sub_event_name.toLowerCase().includes(filterValue)
    });
  }

  addEditSubEvent(action: any, data?: any) {
    if (data) {
      this.mainService.selectedSubEventData = data;
    }
    this.router.navigate(["/add-edit-sub-event/" + action + '/' + this.eventId]);
  }

  goToInvitationAndPresentMember(data: any) {
    const currentDate = new Date();
    const toDate = new Date(data.to_date);
    currentDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
    let dataFlag: boolean = false;
    if (currentDate > toDate) {
      dataFlag = true;
    } else {
      dataFlag = false;
    }
    this.router.navigate(["invitation-present-member/" + data.sub_event_id + '/' + dataFlag]);
  }

  goToAttendanceScanner(data: any) {
    const currentDate = new Date();
    const toDate = new Date(data.to_date);
    currentDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
    let dataFlag: boolean = false;
    if (currentDate > toDate) {
      this.toasterService.toastError("આ કાર્યક્રમ સમાપ્ત થઈ ગયો છે")
    } else {
      this.router.navigate(["/qr-scanner/" + data.sub_event_id]);
    }
  }

  goToEventDonor(data: any) {
    this.router.navigate(["event-donor/" + data.sub_event_id]);
  }

  goToMomentAlbum(data: any) {
    this.router.navigate(["memory/" + data.sub_event_id]);
  }
}
